import styles from './index.module.scss';
import React, {useEffect, useRef, useState} from "react";
import {Input, Typography, Space, Button, message, Empty, Select} from "antd";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import SvgIcon from "@/pages/components/SvgIcon";
import {PrimaryColor} from "@/const";
import HeaderTitle from "@/pages/components/HeaderTitle/index.jsx";
import ApplicationCard from "@/pages/MyApplication/ApplicationCard/index.jsx";
import {useNavigate} from "react-router-dom";
import ChoiceApplication from "@/pages/HomeApplication/ChoiceApplication.jsx";
import {SortContainer} from "@/pages/AddApplication/ParamsList/index.jsx";
import {arrayMove, SortableElement, SortableHandle} from "react-sortable-hoc";
import {HolderOutlined} from "@ant-design/icons";
import {
  getHomeApplicationTypeList,
  onPublishHomeApplication
} from "@/services/application.js";
import LoadingComponent from "@/pages/components/LoadingComponent";
import {v4} from "uuid";
import CustomerConfirm, {customerSuccess} from "@/common/utils/CustomerConfirm";
import MaintenanceDetail from '../WorkflowManagement/MaintenanceDetail';
import { getDetailWords } from '../WorkflowManagement/MaintenanceDetail/detailMessages';
import { useTranslation } from 'react-i18next';
import { applicationTarget } from '../WorkflowManagement/MaintenanceDetail/detailModel';
import { captureDetailReturn } from '../WorkflowManagement/MaintenanceDetail/detailReturn';
import { getLabels, getClassifications } from '@/services/workflow';

import menuChangeListener_instance from '@/lib/menuChangeListener';

const {Link} = Typography;
const { Option } = Select;

// 应用组类型选项
const APP_GROUP_TYPE_OPTIONS = [
  { label: '应用', value: 'APP' },
  { label: '工作流', value: 'WORKFLOW' },
  { label: '智能体', value: 'AGENT' }
];

const SortAbleHand = SortableHandle(({children}) => {
  return (<span>
      <HolderOutlined style={{color: 'rgba(0,0,0,0.25)'}}/>
    {children}
    </span>)
})

const SortElement = SortableElement((data) => {
  const {item, currentActiveId, onClick, onRefresh, len} = data;

  return <TypeOne
    title={item.title}
    status={item.status}
    type={item.type}
    onRefresh={onRefresh}
    id={item.id}
    active={item.id === currentActiveId}
    onClick={() => {
      onClick(item.id);
    }}
  />
})

export const SortCardElement = SortableElement((data) => {
  const {item, onClick, onEdit, sorted} = data;
  const detailButton = useRef();
  const { i18n } = useTranslation();
  const maintenance = ['AGENT', 'WORKFLOW'].includes(item.type?.type || item.type);
  return <div className={styles.SortCardElement}>
    <ApplicationCard
      cardInfo={item}
      onClick={() => onClick?.(detailButton.current)}
      detailButtonRef={maintenance ? detailButton : undefined}
      detailActionLabel={getDetailWords(i18n.language?.startsWith('en') ? 'en' : 'zh').details}
      editDelete={true}
      onEdit={(type) => {
        onEdit?.(type)
      }}
      sortHandRender={sorted ? <SortAbleHand/> : null}
    />
  </div>
})

function TypeOne({title, onClick, status, active, id, type, onRefresh}) {

  const [editAble, setEditAble] = useState(status === 'edit');
  const [editTitle, setEditTitle] = useState(title);
  const [editType, setEditType] = useState(type || 'APP');

  useEffect(() => {
    setEditAble(status === 'edit');
  }, [status]);

  const onChangeEditAble_true = (e) => {
    setEditAble(true);
  }

  const onChangeEditAble_false = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setEditAble(false);
  }

  const onUpdateType = async (e) => {

    if(!editTitle){
      message.warning('应用组名称不能为空');
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    setEditAble(false);
    onRefresh?.('edit', id, editTitle, editType);
    return;
  }

  const onDelete = async () => {
    onRefresh?.('del', id, editTitle);
    return;
  }

  const getTypeLabel = (typeValue) => {
    const option = APP_GROUP_TYPE_OPTIONS.find(opt => opt.value === typeValue);
    return option ? option.label : typeValue;
  };

  return (
    <div
      className={`${styles.typeContainer} ${active ? styles.active : ''} ${editAble ? styles.editing : ''}`}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        onClick?.();
      }}
    >
      <SortAbleHand>
        <span className={styles.sortText}></span>
      </SortAbleHand>
      {
        editAble ? (
          <div className={styles.editContainer}>
          <Input
            value={editTitle}
              style={{width: '100%'}}
              placeholder="组名称"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onChange={(e) => {
              const value = e.target.value;
              setEditTitle(value);
            }}
          />
            <Select
              value={editType}
              style={{width: '100%'}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onChange={(value) => {
                setEditType(value);
              }}
              options={APP_GROUP_TYPE_OPTIONS}
            />
          </div>
        ) : (
          <div className={styles.titleContainer}>
          <div className={styles.title} title={title}>{title}</div>
            <div className={styles.typeLabel}>{getTypeLabel(type)}</div>
          </div>
        )
      }

      {
        // 始终显示操作区域，但根据disabled状态控制删除按钮
          <div className={styles.operate}>
            {
              editAble ? (
                <Space>
                  <Link
                    style={{color: 'rgba(0,0,0,0.65)', fontSize: '12px'}}
                    onClick={onChangeEditAble_false}
                  >
                    取消
                  </Link>
                  <Link
                    onClick={onUpdateType}
                    style={{fontSize: '12px'}}
                  >
                    确定
                  </Link>
                </Space>
              ) : (
                <Space className={styles.operateButton}>
                  <SvgIcon
                    name={'edit'}
                    className={styles.buttonStyle}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();

                      onChangeEditAble_true();
                    }}
                  />
                  <SvgIcon
                    name={'delete'}
                    className={styles.buttonStyle}
                    style={{color: 'red'}}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();

                      onDelete();
                    }}
                  />
                </Space>
              )
            }
          </div>
      }
    </div>
  )
}

function HomeApplication() {

  const navigate = useNavigate();
  const [currentActiveId, setCurrentActiveId] = useState('')
  const [typeList, setTypeList] = useState([]);
  const [cardList, setCardList] = useState([]);
  const [loading, setLoading] = useState(false);
  const typeListRef = useRef([]);
  const oldListRef = useRef([]);
  
  // 详情弹窗状态
  const [detailTarget, setDetailTarget] = useState(null);
  const detailTrigger = useRef(null);
  const [labels, setLabels] = useState([]);
  const [classifications, setClassifications] = useState([]);

  useEffect(() => {
    menuChangeListener_instance.addPageChangeListener(checkHadChange)
    getTypeList();
    loadLabelsAndClassifications();
  }, []);

  // 加载标签和分类数据
  const loadLabelsAndClassifications = async () => {
    try {
      const [labelsRes, classificationsRes] = await Promise.all([
        getLabels(),
        getClassifications()
      ]);
      
      if (labelsRes.success) {
        setLabels(labelsRes.data || []);
      }
      
      if (classificationsRes.success) {
        setClassifications(classificationsRes.data || []);
      }
    } catch (error) {
      console.error('加载标签和分类数据失败:', error);
    }
  };

  const showMaintenanceDetail = (kind, item, trigger) => {
    detailTrigger.current = captureDetailReturn(trigger);
    try { setDetailTarget(applicationTarget(kind, item)); }
    catch { setDetailTarget({ kind, id: null }); }
  };

  const checkHadChange = (fn) => {

    const newList = typeListRef.current.map(item => {
      return {
        title: item.title,
        type: item.type,
        appId: item.children.map(item => item.id)
      }
    }).sort((a, b) => String(a.title).localeCompare(String(b.title)));

    const oldList = oldListRef.current?.map(item => {
      return {
        title: item.title,
        type: item.type,
        appId: item.children.map(item1 => item1.id)
      }
    }).sort((a, b) => String(a.title).localeCompare(String(b.title)));

    if(JSON.stringify(newList) != JSON.stringify(oldList)){
      CustomerConfirm({
        title: '变更内容未保存,确定要离开吗？',
        onOk: () => {
          fn?.()
        }
      })
      return true;
    }

  }

  const getTypeList = async () => {
    const res = await getHomeApplicationTypeList();
    if (res.success) {
      console.log('服务端返回的原始数据:', res.data);
      const list = res.data.map(item => {
        console.log('处理应用组项:', item);
        console.log('应用组类型:', item.type);
        if (item.type === 'AGENT' && item.app && item.app.length > 0) {
          console.log('智能体应用示例:', item.app[0]);
          console.log('智能体workFlow字段:', item.app[0].workFlow);
          console.log('智能体基本字段:', {
            name: item.app[0].name,
            description: item.app[0].description,
            coverImage: item.app[0].coverImage,
            createBy: item.app[0].createBy
          });
        }
        // 使用服务端返回的真实ID，如果没有则生成UUID（用于新增的应用组）
        const id = item.id || item.groupId || v4();

        // 处理应用数据，适配新的数据结构
        const processedApps = (item.app || []).map(app => {
          if (typeof app === 'object' && app !== null) {
            // 基础应用信息
            const baseApp = {
              id: app.appId || app.id,
              appId: app.appId || app.id,
              name: app.name,
              description: app.description,
              createBy: app.createBy,
              groupId: app.groupId, // 保留应用自身的groupId
              type: app.type || item.type || 'APP' // 使用应用自身的type，然后是应用组的type，最后默认APP
            };

            // 根据应用组类型添加特殊字段
            if (item.type === 'AGENT') {
              // 智能体应用需要额外字段
              // 如果app.workFlow为空，使用app本身的数据构建workFlow对象
              const workFlowData = app.workFlow || {};
              
              baseApp.workFlow = {
                ...workFlowData,
                // 确保基本显示字段存在
                titleCn: workFlowData.titleCn || app.name || app.titleCn,
                titleEn: workFlowData.titleEn || app.nameEn || app.titleEn,
                detailCn: workFlowData.detail || workFlowData.detailCn || app.description || app.detailCn,
                detailEn: workFlowData.detailEn || app.descriptionEn || app.detailEn,
                coverImage: workFlowData.coverImage || app.coverImage,
                createBy: workFlowData.createBy || app.createBy,
                points: workFlowData.points || app.points,
                sign: workFlowData.sign || app.sign,
                status: workFlowData.status || app.status
              };
              
              // 确保baseApp也有description字段作为最终回退
              baseApp.detailCn = workFlowData.detail || workFlowData.detailCn || app.description || app.detailCn;
              baseApp.detailEn = workFlowData.detailEn || app.descriptionEn || app.detailEn;
              
              baseApp.configCn = app.configCn; // 智能体配置（中文）
              baseApp.configEn = app.configEn; // 智能体配置（英文）
              baseApp.usage = app.usage; // 使用次数
              baseApp.workFlowId = app.workFlowId || app.id; // 工作流ID，确保有值
              
              console.log('智能体数据处理:', {
                appId: baseApp.id,
                appName: baseApp.name,
                workFlowId: baseApp.workFlowId,
                originalWorkFlowId: app.workFlowId,
                originalId: app.id
              });
            } else if (item.type === 'WORKFLOW') {
              // 工作流应用需要额外字段
              baseApp.titleCn = app.titleCn;
              baseApp.titleEn = app.titleEn;
              baseApp.detailCn = app.detailCn;
              baseApp.detailEn = app.detailEn;
              baseApp.coverImage = app.coverImage;
              baseApp.points = app.points;
              baseApp.sign = app.sign;
              baseApp.status = app.status;
            }

            return baseApp;
          }
          return app;
        });

        return {
          title: item.title,
          id: id,
          uuid: id,
          groupId: (() => {
            // 如果服务端返回了groupId，使用它；否则使用应用组的id作为groupId
            const finalGroupId = item.groupId !== undefined && item.groupId !== null ? item.groupId : item.id;
            console.log(`应用组 "${item.title}" - 原始groupId: ${item.groupId}, 应用组ID: ${item.id}, 最终groupId: ${finalGroupId}, 类型: ${typeof finalGroupId}`);
            return finalGroupId;
          })(), // 使用服务端返回的groupId，如果未定义则使用应用组ID
          status: 'view',
          type: item.type || 'APP', // 添加类型字段
          children: processedApps,
        }
      });

      oldListRef.current = JSON.parse(JSON.stringify(list));

      setTypeList(list);
      typeListRef.current = list;

      if (res.data?.length) {
        setCurrentActiveId(list[0].id);
        getCurrentTypeDetail(list[0].id);
      }
    }
  }

  const onSave = async () => {
    const data = typeList.map(item => {
      return {
        title: item.title,
        type: item.type || 'APP', // 添加类型字段
        appId: item.children.map(childItem => {
          // 根据应用类型使用正确的ID字段
          if (childItem.type === 'AGENT') {
            // 智能体使用workFlowId
            return childItem.workFlowId || childItem.id || childItem.appId;
          } else if (childItem.type === 'WORKFLOW') {
            // 工作流使用id
            return childItem.id || childItem.appId;
          } else {
            // APP类型使用appId或id
            return childItem.appId || childItem.id;
          }
        })
      }
    })
    
    console.log('发布数据:', JSON.stringify(data, null, 2));
    
    try {
    const res = await onPublishHomeApplication({groupList: data});
    if (res.success) {
        // 重新获取数据以获得最新的groupId
        await getTypeList();
        message.success('发布成功');
      } else {
        message.error(res.message || '发布失败');
      }
    } catch (error) {
      console.error('发布失败:', error);
      message.error('发布失败，请重试');
    }
  }

  const onSortEnd = async ({newIndex, oldIndex}) => {
    const tempList = arrayMove(typeList, oldIndex, newIndex);

    setTypeList(tempList);
    typeListRef.current = tempList;
  }

  const onCardSortEnd = ({newIndex, oldIndex}) => {
    const tempList = arrayMove(cardList, oldIndex, newIndex);
    setCardList(tempList);

    setTypeList(list => {
      list.forEach(item => {
        if(item.id === currentActiveId){
          item.children = tempList;
        }
      });
      typeListRef.current = list;

      return list;
    });
  }

  const addType = () => {
    // 移除同名检查，允许应用组同名
    setTypeList(list => {
      const id = v4();
      const newItem = {
        title: '应用组',
        id: id,
        uuid: id,
        groupId: null, // 新增的应用组还没有服务端groupId
        status: 'edit',
        type: 'APP', // 默认类型
        children: [],
      };
      const newList = [...list, newItem];
      typeListRef.current = newList;
      
      // 设置焦点到新建的应用组
      setCurrentActiveId(id);
      setCardList([]);
      
      return newList;
    })
  }

  const onChangeApplication = (apps) => {

    return new Promise(resolve => {
      // 添加调试信息
      console.log('选择的应用:', apps.map(app => ({
        id: app.id,
        appId: app.appId,
        workFlowId: app.workFlowId,
        type: app.type,
        name: app.name
      })));

      setTypeList(list => {
        const _list = JSON.parse(JSON.stringify(list));
        _list.forEach(item => {
          if (item.id === currentActiveId) {
            // 确保每个应用都有必要的字段
            item.children = apps.map(app => ({
              ...app,
              // 确保智能体有workFlowId字段
              workFlowId: app.workFlowId || app.id,
              // 确保有appId字段
              appId: app.appId || app.id
            }));
          }
        });

        setTypeList(_list);
        typeListRef.current = _list;

        setCardList(_list.find(item => item.id === currentActiveId)?.children || []);

        return _list;
      })
      resolve(true);
    });
  }

  const onTypeOperation = (type, id, title, groupType) => {
    if (type === 'del') {

      CustomerConfirm({
        title: '删除应用组',
        content: `确定删除${title}吗？,删除后应用组中的应用也将被删除`,
        onOk: () => {
          const _list = typeList.filter(item => item.id !== id);
          setTypeList(_list);
          typeListRef.current = _list;

          if (_list.length > 0) {
          setCurrentActiveId(_list[0].id);
          setCardList(_list[0].children || []);
          } else {
            setCurrentActiveId('');
            setCardList([]);
          }
        },
        okText: '删除'
      })

    } else if (type === 'edit') {
      // 移除同名检查，允许应用组同名
      setTypeList(list => {
        const _list = JSON.parse(JSON.stringify(list));
        _list.forEach(item => {
          if (item.id === id) {
            item.title = title;
            item.type = groupType || 'APP';
            item.status = 'view';
          }
        });

        typeListRef.current = _list;
        return _list;
      })
    }
  }

  const getCurrentTypeDetail = (id) => {
    const currentType = typeListRef.current.find(item => item.id === id);
    setCardList(currentType?.children || []);
  }

  const getCurrentGroupType = () => {
    const currentType = typeListRef.current.find(item => item.id === currentActiveId);
    return currentType?.type || 'APP';
  }

  return (
    <div className={styles.container}>
      <HeaderTitle
        title={'首页应用'}
        rightRender={<Button type={'primary'} onClick={onSave}>发布</Button>}
      />

      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.header}>
            <div className={styles.title}>应用组</div>
            <div className={styles.addGroup}>
              <Link
                onClick={() => {
                  addType();
                }}
              >
                <PlusOutlined style={{marginRight: '4px'}}/>
                添加应用组
              </Link>
            </div>
          </div>

          <div className={styles.group}>
            <SortContainer onSortEnd={onSortEnd} useDragHandle>
              {
                typeList.map((item, index) => {
                  return (
                    <SortElement
                      index={index}
                      key={item.id}
                      onRefresh={(type, id, title, groupType) => {
                        onTypeOperation(type, id, title, groupType);
                      }}
                      len={typeList.length}
                      item={item}
                      currentActiveId={currentActiveId}
                      onClick={(id) => {
                        setCurrentActiveId(id);
                        getCurrentTypeDetail(id);
                      }}
                    />
                  )
                })
              }
            </SortContainer>
          </div>

        </div>
        <div className={styles.right}>
          <div className={styles.headerLine}>
            <Button
              type={'primary'}
              onClick={() => {
                const currentGroupType = getCurrentGroupType();
                const ids = cardList;
                ChoiceApplication(ids, (choiceList) => {
                  return onChangeApplication(choiceList);
                }, currentGroupType)
              }}
            >
              选择{getCurrentGroupType() === 'APP' ? '应用' : getCurrentGroupType() === 'WORKFLOW' ? '工作流' : '智能体'}
            </Button>
          </div>

          {
            loading && <LoadingComponent/>
          }

          {
            !loading && cardList.length === 0 ? (
              <Empty description={'暂无数据'}/>
            ) : (
              <SortContainer
                onSortEnd={onCardSortEnd}
                useDragHandle
                axis={'xy'}
              >
                <div className={styles.cardContainer}>
                  {
                    cardList.map((item, index) => {
                      return (
                        <SortCardElement
                          index={index}
                          key={item.id || item.appId}
                          item={{
                            ...item,
                            type: {
                              type: item.type
                            }
                          }}
                          sorted={true}
                          onEdit={async (type) => {
                            if (type === 'delete') {

                              // 修复：只从当前应用组中删除智能体，不影响其他组
                              const _typeList = typeList.map(item1 => {
                                // 只在当前活跃的应用组中删除
                                if (item1.id === currentActiveId) {
                                  return {
                                    ...item1,
                                    children: item1.children.filter(item2 => (item2.id || item2.appId) !== (item.id || item.appId))
                                  }
                                }
                                // 其他应用组保持不变
                                return item1;
                              })

                              const _cardList = cardList.filter(item2 => (item2.id || item2.appId) !== (item.id || item.appId))

                              setCardList(_cardList);
                              setTypeList(_typeList);
                              typeListRef.current = _typeList;
                            }

                          }}
                          onClick={trigger => {
                            const currentGroup = typeListRef.current.find(group => group.id === currentActiveId);
                            let groupId = currentGroup?.groupId !== undefined ? currentGroup.groupId : (currentGroup?.id || 0); // 使用groupId，如果未定义则使用应用组ID
                            const cardType = item.type?.type || item.type;
                            
                            // 正确逻辑：根据应用自身的groupId字段判断
                            // 如果应用的groupId为"0"、0或null，说明是官方应用
                            if (item.groupId === "0" || item.groupId === 0 || item.groupId === null || item.groupId === undefined) {
                              groupId = 0;
                            } else {
                              // 用户应用使用其自身的groupId
                              groupId = item.groupId;
                            }
                            
                            console.log(`点击应用卡片:`, {
                              appId: item.id || item.appId,
                              appName: item.name,
                              appCreateBy: item.createBy,
                              appOwnGroupId: item.groupId, // 应用自身的groupId
                              cardType,
                              currentActiveId,
                              applicationGroupId: currentGroup?.groupId, // 应用组的groupId
                              finalGroupId: groupId,
                              groupIdType: typeof groupId
                            });
                            
                            // 根据应用类型处理不同的显示方式
                            switch(cardType) {
                              case 'WORKFLOW':
                                // 显示工作流详情弹窗
                                showMaintenanceDetail('workflow', item, trigger);
                                break;
                              
                              case 'AGENT':
                                // 显示智能体详情弹窗，使用workFlowId作为agentId
                                showMaintenanceDetail('agent', item, trigger);
                                break;
                              
                              case 'APP':
                              default:
                                // APP类型继续跳转到应用详情页面
                            navigate({
                              pathname: '/view-application',
                                  search: `id=${item.id || item.appId}&groupId=${groupId}`
                                });
                                break;
                            }
                          }}
                        />
                      )
                    })
                  }

                </div>
              </SortContainer>
            )
          }

        </div>
      </div>
      
      {/* 工作流详情弹窗 */}
      <MaintenanceDetail visible={!!detailTarget} kind={detailTarget?.kind || 'agent'} targetId={detailTarget?.id}
        onCancel={() => setDetailTarget(null)} afterClose={() => { detailTrigger.current?.(); detailTrigger.current = null; }}
        labels={labels} classifications={classifications} />

    </div>
  )

}

export default HomeApplication;
